/**
 * "Reset demo" control (SKE-4166).
 *
 * Clears the visitor's local snapshot and reloads, which rebuilds the pristine
 * curated landing state. Deliberately unobtrusive — later phases own the demo
 * chrome; this is just the escape hatch.
 *
 * Tailwind only (styled-components are lint-blocked in this app). The colour
 * transition is `motion-safe:` so it disappears under
 * `prefers-reduced-motion: reduce`.
 */

import { resetDemo } from './demoApi'
import { demoStrings } from './demoStrings'

const DemoResetButton: React.FC = () => {
  const handleReset = () => {
    resetDemo()
    globalThis.window?.location.reload()
  }

  return (
    <button
      type="button"
      onClick={handleReset}
      aria-label={demoStrings.resetAriaLabel}
      className="fixed bottom-4 right-4 z-50 rounded-full border border-neutral-200 bg-white/90 px-4 py-2 text-sm font-medium text-neutral-600 shadow-sm backdrop-blur hover:bg-white hover:text-neutral-900 motion-safe:transition-colors"
    >
      {demoStrings.resetLabel}
    </button>
  )
}

export default DemoResetButton
